import { TeacherAccount, TeacherProfile } from '~/classroom/types/classroom.types'

/**
 * The login account, turned into what the header avatar and its menu render.
 *
 * Initials come from the name — the first letter of `firstName`, or of `lastName` when only that half
 * is set. The email is the fallback, not the rule: `firstName`/`lastName` are null until an invited
 * teacher sets a name, and that account still needs a letter in its avatar. The name itself falls
 * back to the email's local part, since the menu prints the full address below it.
 */
export const toTeacherProfile = (account: TeacherAccount): TeacherProfile => {
  const email = account.email.trim()
  const fullName = [account.firstName, account.lastName].filter(Boolean).join(' ').trim()
  const name = fullName || email.split('@')[0]

  return {
    name,
    email,
    initials: (name || email).charAt(0).toUpperCase(),
  }
}
